import React from 'react'
import {
  DISPLAY_NAME,
  type ScopedProps,
  useCardInformativeContext,
} from '../../card-informative'
import { CardInformativeTitle } from '../card-informative-title'
import * as C from './card-informative-content.styles'

type CardInformativeContentProps = {
  children: React.ReactNode
  testID?: string
}

export const CardInformativeContent = (props: CardInformativeContentProps) => {
  const { children, testID, __scopeCardInformative } =
    props as ScopedProps<CardInformativeContentProps>
  const { type } = useCardInformativeContext(
    DISPLAY_NAME,
    __scopeCardInformative
  )

  return (
    <C.Container testID={testID}>
      {React.Children.map(children, child => {
        if (!React.isValidElement(child)) return child

        if (type !== 'highlight' && child.type === CardInformativeTitle) {
          return null
        }

        return child
      })}
    </C.Container>
  )
}
